export default "__VITE_ASSET__CFpEmRTN__"